import * as React from 'react';
import { getEmailTemplates } from '../settings/subSettings/actions';
import { EmailTemplate, EmailTemplateData, EmailTemplateVariable } from './model/models';
import { convertStringToMailtoURL, replaceAllVariable } from '../../components_v2/utils';
import { EmailTemplatePopupContainer, Item, List } from './style/styles';
import { translateToString } from '../../styles/global/translate';
import { Link } from 'react-router-dom';
import { PrimaryColor } from '../../styles/global/css/Utils';
import { TableCellButton } from '../client-companies/style/Style';
import { Mail } from 'lucide-react';


interface HoverEmailWrapperProps {
	emailTemplateVariable: EmailTemplateVariable
	email: string,
	parent?
}
export function HoverEmailWrapper(props: HoverEmailWrapperProps) {
	const [isEmailTemplateOpen, setIsEmailTemplateOpen] = React.useState(false);

	return (<>
		<EmailTemplatePopup
			emailTemplateVariable={props.emailTemplateVariable}
			email={props.email ?? ''}
			isOpen={isEmailTemplateOpen}
			onClose={() => setIsEmailTemplateOpen(false)}
		/>
		<TableCellButton parent={props.parent} onClick={() => setIsEmailTemplateOpen(prev => !prev)} icon={Mail} />
	</>);
}

let emailTemplatesCache: EmailTemplate[] | null = null;

interface EmailTemplatePopupProps {
	emailTemplateVariable: EmailTemplateVariable
	email: string
	isOpen: boolean
	onClose: () => void
	quickAction?: boolean
}
export default function EmailTemplatePopup({ emailTemplateVariable, email, isOpen, onClose, quickAction }: EmailTemplatePopupProps) {
	const [emailTemplates, setEmailTemplates] = React.useState<EmailTemplate[]>([]);
	const fetchEmailTemplates = React.useCallback(() => {
		if (emailTemplatesCache !== null) {
			setEmailTemplates(emailTemplatesCache);
			return;
		}
		getEmailTemplates()
			.then((templates) => {
				setEmailTemplates(templates);
				emailTemplatesCache = templates;
			});
	}, []);

	function handleSendEmailTemplate(emailTemplateData: EmailTemplateData) {
		const { subject, body } = emailTemplateData;

		const parsedBody = replaceAllVariable(emailTemplateVariable, body);
		const mailtoURL = convertStringToMailtoURL(email, { subject, body: parsedBody });
		window.open(mailtoURL);
		onClose();
	}

	function handleSendEmail() {
		window.open(`mailto:${email}`);
		onClose();
	}
	React.useEffect(() => {
		fetchEmailTemplates();
	}, []);

	const listStyle = quickAction ? { top: '20px', right: '-100px' } : {};

	if (!isOpen) return null;
	return <EmailTemplatePopupContainer>
		{
			<List {...listStyle}>
				<Item pointer borderBottom onClick={handleSendEmail}>{translateToString('email_template.new_email')}</Item>
				{
					emailTemplates.length > 0 ? emailTemplates
						.map((el, index) =>
							<Item
								key={el.name + el.id}
								onClick={() => handleSendEmailTemplate(el.data)}
								borderBottom={index + 1 === emailTemplates.length}
								pointer
								ellipsis
							>{el.name}</Item>
						)
						: <Item borderBottom>
							{translateToString('email_template.no_available_email_template')}
						</Item>
				}
				<Link to="/settings#email_template_list">
					<Item color={`${PrimaryColor}`} fontWeight="400">{translateToString('email_template.create_new_template')}</Item>
				</Link>
			</List>

		}
	</EmailTemplatePopupContainer>;
}
